(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('AppraisalScrubController', AppraisalScrubController);

    AppraisalScrubController.$inject = ['$sce', 'orderId', 'versions', 'AppraisalScrub', 'ProfileService'];

    function AppraisalScrubController($sce, orderId, versions, AppraisalScrub, ProfileService) {
        var vm = this;

        vm.orderId = orderId;
        vm.versions = versions;
        vm.selectedId = versions && versions.length ? versions[0].id : null;
        vm.selected = null;         // full DTO for the selected version (includes resultJson)
        vm.parsedResult = null;     // resultJson parsed to an object for pretty display
        vm.rescrubbing = false;
        vm.useMockResponse = false; // dev-only: reset each visit; ticked to stub in the saved response
        vm.showMock = false;        // non-prod checkbox: shown only in local / dev / uat profiles

        vm.loadVersion = loadVersion;
        vm.requestReScrub = requestReScrub;

        // Only non-prod runs honor the saved-response stub (valueconnect.ai.mock-enabled); hide the box in prod.
        ProfileService.getProfileInfo().then(function (info) {
            var mockProfiles = ['local', 'staging', 'ha-uat']; // local + dev + uat
            vm.showMock = !!(info && info.activeProfiles && info.activeProfiles.some(function (p) {
                return mockProfiles.indexOf(p) !== -1;
            }));
        });

        if (vm.selectedId) {
            loadVersion();
        }

        function loadVersion() {
            if (!vm.selectedId) {
                vm.selected = null;
                vm.parsedResult = null;
                return;
            }
            AppraisalScrub.get({ id: vm.selectedId }).$promise.then(function (data) {
                vm.selected = data;
                vm.parsedResult = null;
                vm.pdfUrl = null;
                vm.pdfDownloadUrl = null;
                if (data.resultJson) {
                    try {
                        vm.parsedResult = angular.fromJson(data.resultJson);
                    } catch (e) {
                        vm.parsedResult = null;
                    }
                }
                if (data.status === 'COMPLETE') {
                    vm.pdfDownloadUrl = 'api/scrub-results/' + data.id + '/pdf';
                    vm.pdfUrl = $sce.trustAsResourceUrl(vm.pdfDownloadUrl);
                }
            });
        }

        function requestReScrub() {
            vm.rescrubbing = true;
            // useMock is a non-template param → $resource sends it as a query string (?useMock=true).
            AppraisalScrub.reScrub({ orderId: vm.orderId, useMock: vm.useMockResponse }, {}, onSuccess, onError);

            function onSuccess() {
                // Refresh the version list and select the newest (the just-created PENDING one).
                AppraisalScrub.getByOrder({ orderId: vm.orderId }).$promise.then(function (list) {
                    vm.versions = list;
                    vm.selectedId = list && list.length ? list[0].id : null;
                    vm.rescrubbing = false;
                    loadVersion();
                });
            }

            function onError() {
                vm.rescrubbing = false;
            }
        }
    }
})();
